import { FC } from "react";
import PageSection from "../../parts/StaticPageSection";
import { Helmet } from "react-helmet";
import { LecalSection } from "../../parts/LecalSection";

export const PrivacyPolicyPage: FC = () => {
  return <>
    <Helmet>
      <title>プライバシーポリシー - Drop AI</title>
      <meta name="description" content="Drop AIのプライバシーポリシーを確認できます。" />

      <meta property="og:url" content="https://drop4i.com/privacy-policy" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="プライバシーポリシー - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="Drop AIのプライバシーポリシーを確認できます。" />
    </Helmet>
    <PageSection title="プライバシーポリシー">  
      <div>株式会社 GO TO MARKET（以下「当社」といいます。）は、当社の提供するDrop AI（ https://drop4i.com、以下「本サービス」といいます。理由の如何を問わず、本サービスにおける、利用者についての個人情報を含む利用者情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。</div>

<LecalSection title="1. 収集する利用者情報及び収集方法" value={`本ポリシーにおいて、「利用者情報」とは、利用者の識別に係る情報、通信サービス上の行動履歴、その他利用者または利用者の端末に関連して生成または蓄積された情報であって、本ポリシーに基づき当社が収集するものを意味するものとします。
本サービスにおいて当社が収集する利用者情報は、その収集方法に応じて、以下となります。

(1) サービス利用情報
本サービスを利用するために、または本サービスの利用を通じて利用者からご提供いただく情報は以下のとおりです。
・アカウント名(ニックネームを含む)、メールアドレス、クレジットカードなど決済手段や請求先住所など決済に関連する情報

(2) 利用者が本サービスの利用において、他のサービスと連携を許可することにより、当該サービスからご提供いただく情報
利用者が、本サービスを利用するにあたり、Google等の外部サービスとの連携を許可した場合には、その許可の際にご同意いただいた内容に基づき、以下の情報を当該外部サービスから収集します。
・当該外部サービスで利用者が利用するID情報
・その他当該外部サービスのプライバシー設定により利用者が連携先に開示を認めた情報

(3) 利用者が本サービスを利用するにあたって、当社が収集する情報
当社は、本サービスへのアクセス状況やそのご利用方法に関する情報を収集することがあります。これには以下の情報が含まれます。
・リファラ
・IPアドレス
・サーバーアクセスログ、サービス内での行動履歴に関する情報
・Cookie、ADID、IDFAその他の識別子`}></LecalSection>

<LecalSection title="2. 利用目的" value={`本サービスのサービス提供にかかわる利用者情報の具体的な利用目的は以下のとおりです。
(1) 本サービスに関する登録の受付、本人確認、利用者認証、利用者設定の記録、利用料金の決済計算等本サービスの提供、維持、保護及び改善のため
(2) 本サービスの品質向上のため
(3) 利用者のトラフィック測定及び行動測定のため
(4) 広告の配信、表示及び効果測定のため（広告主又はアフィリエイトサービスプロバイダー（以下「広告主等」といいます。）に対してCookie情報その他成果測定に必要な情報を提供の上、広告主等が自らの保有する個人データと照合の上、成果測定を行うことがあります。）
(5) 本サービスに関するご案内、お問い合わせ等への対応のため
(6) 市場調査、分析、広告宣伝などマーケティング及び調査研究のため
(7) 個人を識別できない形式に加工した統計データを作成するため
(8) 本サービスに関する当社の利用規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため
(9) 本サービスに関する規約等の変更などを通知するため`}></LecalSection>

<LecalSection title="3. 通知・公表または同意取得の方法、利用中止要請の方法" value={`利用者は、本サービスの所定の設定を行うことにより、利用者情報の全部または一部についてその収集又は利用の停止を求めることができ、この場合、当社は速やかに、当社の定めるところに従い、その利用を停止します。なお利用者情報の項目によっては、その収集または利用が本サービスの前提となるため、当社所定の方法により本サービスを退会した場合に限り、当社はその収集又は利用を停止します。`}></LecalSection>


<LecalSection title="4. 第三者提供" value={`4-1 当社は、利用者情報のうち、個人情報については、あらかじめ利用者の同意を得ないで、第三者（日本国外にある者を含みます。）に提供しません。但し、次に掲げる必要がある場合はこの限りではありません。
(1) 当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
(2) 合併その他の事由による事業の承継に伴って個人情報が提供される場合
(3)国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用者の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合
(4) その他、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）その他の法令で認められる場合
4-2 当社は、第1項にかかわらず、本サービスの品質向上、市場調査、分析、広告宣伝等マーケティング、及び調査研究を目的とし、利用者個人を特定できないよう不可逆的かつ適切な加工を行った利用者情報を、当社と取引のある第三者に対し、データ送信、磁気媒体、紙面及び口頭等の方法により提供する場合があり、利用者はかかる第三者提供につき予め同意するものとします。`}></LecalSection>

<LecalSection title="5. 個人情報の管理" value={`本サービスは、利用者からご提供いただいた情報の管理について、以下を徹底します。
(1)利用者からご提供いただいた情報については、常に正確かつ最新の情報となるよう努めます。
(2) 本サービスは、個人情報の漏えいや滅失又は棄損を防止するために、適切なセキュリティ対策を実施して個人情報を保護します。
(3) 個人情報が不要となった場合には、廃棄します。`}></LecalSection>

<LecalSection title="6. 個人情報の開示" value={`当社は、利用者から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、利用者ご本人からのご請求であることを確認の上で、利用者に対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり1,000円）を頂戴しておりますので、あらかじめ御了承ください。

当社は、利用者から、個人情報保護法の定めに基づき個人情報の開示を求められたときは、利用者ご本人からのご請求であることを確認の上で、利用者に対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり1,000円）を頂戴しておりますので、あらかじめ御了承ください。`}></LecalSection>

<LecalSection title="7. 個人情報の訂正及び利用停止等" value={`7-1 当社は、利用者から、(1)個人情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合、及び(2)あらかじめ公表された利用目的の範囲を超えて取扱われているという理由または偽りその他不正の手段により収集されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止を求められた場合には、利用者ご本人からのご請求であることを確認の上で遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正または利用停止を行い、その旨を利用者に通知します。なお、訂正または利用停止を行わない旨の決定をしたときは、利用者に対しその旨を通知いたします。
7-2当社は、利用者から、利用者の個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、利用者ご本人からのご請求であることを確認の上で、個人情報の消去を行い、その旨を利用者に通知します。
7-3個人情報保護法その他の法令により、当社が訂正等または利用停止等の義務を負わない場合は、7-1および7-2の規定は適用されません。`}></LecalSection>

<LecalSection title="8. 第三者によるCookie情報の取得等について" value={`8-1 本サービスでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。このGoogleアナリティクスはアクセス情報の収集のためにCookieを使用しています。このアクセス情報は匿名で収集されており、個人を特定するものではありません。
8-2 お使いのブラウザの操作によりCookieを無効にすることで、収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。
8-3 Googleアナリティクスの利用規約に関して確認したい場合は、ここをクリックしてください。また、「ユーザーが Google パートナーのサイトやアプリを使用する際の Google によるデータ使用」に関して確認したい場合は、ここをクリックしてください。なお、Google アナリティクスのサービス利用による損害については、当社は責任を負わないものとします
8-4 本サービスでは、GoogleやFacebook、Yahoo!Japan などをはじめとする第三者から配信される広告が掲載される場合があり、これに関連して当該第三者が利用者のCookie情報等を取得して、利用している場合があります。当該第三者によって取得されたCookie情報等は、当該第三者のプライバシーポリシーに従って取り扱われます。
8-5 利用者は、当該第三者のウェブサイト内に設けられたオプトアウト（個人情報を第三者に提供することを停止すること）ページにアクセスして、当該第三者によるCookie情報等の広告配信への利用を停止することができます。`}></LecalSection>

<LecalSection title="9. Cookie情報の送受信の許可・拒否について" value={`利用者は、Cookieの送受信に関する設定を「すべてのCookieを許可する」、「すべてのCookieを拒否する」、「Cookieを受信したらユーザーに通知する」などから選択できます。設定方法は、ブラウザにより異なります。Cookieに関する設定方法は、お使いのブラウザの「ヘルプ」メニューでご確認ください。すべてのCookieを拒否する設定を選択されますと、認証が必要なサービスを受けられなくなる等、インターネット上の各種サービスの利用上、制約を受ける場合がありますのでご注意ください。`}></LecalSection>

<LecalSection title="10. 個人関連情報の取得" value={`当社は、氏名等の利用者を特定する情報を保有しない第三者から、識別子や行動履歴など、利用者に関連する情報（個人関連情報）の提供を受け、当該情報を当社が管理する利用者の個人情報と紐づけることで個人情報として取得し、別途の目的が示されている場合を除き、上記「2.利用目的」で規定した目的にしたがって、当該情報を利用することがございます。具体的には、Cookie等、モバイル広告識別子、メールアドレスや電話番号（不可逆的な変換処理がなされたものを含みます。）、広告の閲覧回数等の広告配信関連ログ、ウェブサイトの閲覧履歴や検索履歴、位置情報その他の行動履歴等を取得し、当社が管理する個人情報と紐づけて利用する場合がございます。この場合は、個人情報保護法をはじめとした適用法令に従い、個人情報として適切に取り扱います。`}></LecalSection>

<LecalSection title="11. お問い合わせ窓口" value={`ご意見、ご質問、苦情のお申出その他利用者情報の取扱いに関するお問い合わせは、下記メールアドレスにてお問い合わせください。
メールアドレス：support_drop.ai@go2mkt.co.jp`}></LecalSection>

<LecalSection title="12. プライバシーポリシーの変更手続" value={`当社は、必要に応じて、本ポリシーを変更します。但し、法令上利用者の同意が必要となるような本ポリシーの変更を行う場合、変更後の本ポリシーは、当社所定の方法で変更に同意した利用者に対してのみ適用されるものとします。なお、当社は、本ポリシーを変更する場合には、変更後の本ポリシーの施行時期及び内容を当社のウェブサイト上での表示その他の適切な方法により周知します。`}></LecalSection>
 
 <div className="mt-10">【2024年11月1日制定】</div>
 
    </PageSection>
  </>;
}